module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0023.jpg?v=87eae895";